import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { PlanningsDriverEntity } from 'src/entities/PlanningsDriver.entity';

/**
 * ドライバー一覧のキャッシュキー。staleTime: Infinity なので、ドライバーが増減する
 * 操作のあとは明示的に invalidate しないと古いままになる。
 */
export const PLANNINGS_DRIVERS_QUERY_KEY = 'useQueryPlanningsDrivers';

const requestPath = (startOn: string, endOn: string) => `/api/v3/plannings/${startOn}/drivers?end_on=${endOn}`;

const getAll = (startOn: string, endOn: string) => async () => {
  const response: AxiosResponse<PlanningsDriverEntity[]> = await axios.get(requestPath(startOn, endOn));

  return response.data;
};
export const useQueryPlanningsDrivers = (startOn: string, endOn: string) => useQuery({
  queryKey: [PLANNINGS_DRIVERS_QUERY_KEY, { startOn, endOn }],
  queryFn: getAll(startOn, endOn),
  staleTime: Infinity,
  enabled: Boolean(startOn) && Boolean(endOn)
});
